import {
  Card,
  Group,
  MultiSelect,
  NumberInput,
  Text,
  TextInput,
  rem,
} from '@mantine/core';
import { useEmployeeFormContext } from '../EmployeePersonalSection';
import { BiSolidDownArrow } from 'react-icons/bi';
import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { useEffect, useState } from 'react';
import { type Tags } from '@/schemas/API/GET/tag/response';

interface Location {
  id: number;
  name: string;
}

export const AddressCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const { data: allTags } = useSWR<Tags>(`/tags`, getFetcher);

  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );

  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [selectedLocations, setSelectedLocations] = useState<string[]>([]);

  const { data } = useSWR<{ content: Location[] }>('/localities', getFetcher);

  const locationOptions =
    data?.content?.map(location => ({
      value: location.id.toString(),
      label: location.name,
      id: location.id,
    })) ?? [];

  useEffect(() => {
    if (form.values.tags) {
      setSelectedValues(form.values.tags.map(tag => tag.name));
    }

    if (form.values.locs) {
      setSelectedLocations(form.values.locs.map(loc => loc.id.toString()));
    }
  }, [form.values.tags, form.values.locs]);

  const tagOptions = allTags?.content.map(item => {
    return item.name;
  });

  function handleChangeTags(values: string[]): void {
    setSelectedValues(values);
    form.setFieldValue('tags', []);
    allTags?.content.forEach(tag => {
      if (values.includes(tag.name)) form.insertListItem('tags', tag);
    });
  }

  function handleChangeLocations(values: string[]): void {
    setSelectedLocations(values);
    form.setFieldValue('locs', []);

    locationOptions.forEach(location => {
      if (values.includes(location.value))
        form.insertListItem('locs', location);
    });
  }

  return (
    <Card shadow="sm" padding="md" radius="md" withBorder>
      <Text fw={700} size="lg">
        Adresa
      </Text>

      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="Ulice"
        label="Ulice"
        {...form.getInputProps('permAddress.street')}
      />

      <Group justify="space-between" grow align="start">
        <NumberInput
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="číslo popisné"
          label="Číslo popisné"
          value={form.values.permAddress?.descNum}
          min={0}
          error={form.getInputProps('permAddress.descNum').error}
          allowDecimal={false}
          onChange={(n: any) => {
            form.setFieldValue('permAddress.descNum', Number(n));
          }}
        />

        <NumberInput
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="číslo orientační"
          label="Číslo orientační"
          value={form.values.permAddress?.orientNum}
          min={0}
          error={form.getInputProps('permAddress.orientNum').error}
          allowDecimal={false}
          onChange={(n: any) => {
            form.setFieldValue('permAddress.orientNum', Number(n));
          }}
        />
      </Group>

      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="město"
        label="Město"
        {...form.getInputProps('permAddress.city')}
      />

      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="PSČ"
        label="PSČ"
        {...form.getInputProps('permAddress.postCode')}
      />

      <MultiSelect
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="add tags"
        label="Tagy"
        rightSection={icon}
        value={selectedValues}
        data={tagOptions}
        onChange={values => {
          handleChangeTags(values);
        }}
      />

      <MultiSelect
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="add locations"
        label="Lokace"
        rightSection={icon}
        value={selectedLocations}
        data={locationOptions}
        onChange={values => {
          handleChangeLocations(values);
        }}
      />
    </Card>
  );
};
